import { render, staticRenderFns } from "./PBPInfoMain.vue?vue&type=template&id=b654fbf4&scoped=true"
import script from "./PBPInfoMain.vue?vue&type=script&lang=js"
export * from "./PBPInfoMain.vue?vue&type=script&lang=js"
import style0 from "./PBPInfoMain.vue?vue&type=style&index=0&id=b654fbf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b654fbf4",
  null
  
)

export default component.exports